
<div identity="c-card-options-wrap">
  <cvt-collapse
    :accordion="true"
    :theme="mode === 'LIGHT' ? 'light' : 'dark'"
    :prepend-chevron="prependChevron"
  >
    <div v-if="showOption('desktop')" style="padding: 16px">
      <template-options :mode="mode" :is-card-element="isCardElement" />
    </div>

    <!-- Implement Icon options -->
    <cvt-collapse-item
      title="Button"
      name="Button"
      :special-style="isSpecialStyle"
    >
      <div class="row">
        <div class="col">
          <strong>Enable Button</strong>
        </div>
        <div class="col-3">
          <cvt-switch
            size="xs"
            color="active"
            type="circular"
            description-type="default"
            :initial-state="enableButton"
            :mode="mode"
            @switchToggle="() => onSwitchToggle('enableButton')"
          />
        </div>
      </div>
      <div
        v-if="isCardElement"
        class="row mt-4 d-flex justify-content-between"
      >
        <div class="col-12">
          <alignment
            :component-key="`template/buttonSelfPosition`"
            alignment-label="Positioning"
            :mode="mode"
          />
        </div>
      </div>
    </cvt-collapse-item>

    <!-- Implement Icon options -->
    <cvt-collapse-item
      v-if="showOption('desktop')"
      title="Icon"
      name="Icon"
      :special-style="isSpecialStyle"
    >
      <!--        <div class="d-flex my-2">-->
      <!--          <strong class="mr-2 mb-3">Generative AI</strong>-->
      <!--          <GenAIOptions v-if="genAiEnabled" :mode="mode" />-->
      <!--        </div>-->

      <icon-image-options :mode="mode" />
    </cvt-collapse-item>

    <!-- Headline Text -->
    <cvt-collapse-item
      :title="$t('elements.property.card.element.options.headline')"
      name="headline"
    >
      <div class="d-flex my-2 flex-column">
        <strong class="mr-2 mb-3">Generative AI</strong>
        <GenAIOptions
          v-if="genAiEnabled"
          :mode="mode"
          path-prefix="template/headline"
          selector-value-key="headline/text"
        />
      </div>
      <text-options
        :content="headLineHTML"
        :config="headlineConfig"
        :show-text-editor="!isCardElement"
        :update-key="'headline/enable'"
        :is-enabled="enableHeadline"
        :label="$t('elements.property.card.element.options.edit.headline')"
        @save="(val) => selectAction(val, 'headLineHTML')"
      />
    </cvt-collapse-item>

    <!-- Text -->
    <cvt-collapse-item
      :title="$t('editor.left_nav.element.text')"
      name="text"
    >
      <div class="d-flex my-2 flex-column">
        <strong class="mr-2 mb-3">Generative AI</strong>
        <GenAIOptions
          v-if="genAiEnabled"
          :mode="mode"
          path-prefix="template/subHeadline"
          selector-value-key="subHeadline/text"
        />
      </div>
      <text-options
        :content="textHTML"
        :config="textConfig"
        :update-key="'subHeadline/enable'"
        :show-text-editor="!isCardElement"
        :is-enabled="enableText"
        :label="$t('editor.section.grid_item.edit.btn_text')"
        @save="(val) => selectAction(val, 'textHTML')"
      />
    </cvt-collapse-item>

    <!-- Implement Style options -->
    <cvt-collapse-item
      :title="$t('elements.properties.local.style.label')"
      name="style"
    >
      <style-option :mode="mode" />
    </cvt-collapse-item>

    <!-- Implement Background options -->
    <cvt-collapse-item
      :title="$t('elements.properties.background.color')"
      name="background"
    >
      <background :mode="mode" />
    </cvt-collapse-item>
  </cvt-collapse>
</div>
